<template>
  <div class="home-page">
    <div class="top-wrapper">
      <Swiper :list="bannerList" />
      <SignModule />
    </div>
    <div class="course-list">
      <div class="course-title">
        <div class="left">
          <span></span>
          报名课程
        </div>
        <div class="right" @click="lookMore">更多 >></div>
      </div>
      <TrainingList :list="trainingList" /> 
    </div>
  </div>
</template>

<script>
import Swiper from "./components/swiper";
import SignModule from "./components/signup";
import TrainingList from "./components/trainingList";
import { getBannerList, getTrainingList } from "@/api/home";

export default {
  components: {
    Swiper,
    SignModule,
    TrainingList,
  },
  data() {
    return {
      bannerList: [],
      trainingList: [],
    };
  },
  computed: {
    isLogin() {
      return this.$store.getters["isLogin"];
    },
  },
  async created() {
    const [trainingList = [], bannerList = []] = await Promise.all([
      getTrainingList(),
      getBannerList(),
    ]);
    this.trainingList = trainingList;
    this.bannerList = bannerList;
  },
  methods: {
    lookMore() {
      this.$router.push(`/training-list`);
    },
  },
};
</script>
<style lang="scss">
.el-carousel__button {
  width: 0.1rem;
  height: 0.1rem;
  border-radius: 50%;
}
.home-page {
  min-width: 13.1rem;
  .top-wrapper {
    width: 100%;
    height: 4.75rem;
    position: relative;
  }
  .course-list {
    width: 13.1rem;
    margin: 0 auto;
    padding-top: 1.6rem;
    .course-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .left {
        display: flex;
        align-items: center;
        font-size: 0.2rem;
        color: #005ebd;
        font-weight: bold;
        span {
          display: inline-block;
          width: 0.06rem;
          height: 0.2rem;
          background-color: #005ebd;
          margin-right: 0.1rem;
        }
      }
      .right {
        font-size: 0.16rem;
        color: #333333;
        cursor: pointer;
      }
    }
  }
}
</style>
